export enum HouseSessionEventStatus {
  Generating = 1,
  Completed = 2,
  Failed = 3,
  ConversationGenerated = 4,
}

export enum HouseEventLocation {
  House = 1,
}
